import common from "../hackatao/common.json";

const sources = {
  common,
};

export default sources;
